/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { RiArrowRightFill } from "react-icons/ri";

import SearchField from "components/fields/SearchField";
import { IoIosCopy } from "react-icons/io";
import { PiQuestionLight } from "react-icons/pi";
import { PiEyeLight } from "react-icons/pi";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { FaAngleDown } from "react-icons/fa";
import { useState } from "react";
import { HiOutlineLightBulb } from "react-icons/hi";
import { Link } from "react-router-dom";
import VerifiedIcon from "assets/img/icons/verified.png";
import USDCIcon from "assets/img/icons/usdc.png";
import DexIcon from "assets/img/icons/dex.png";
import TokenTransfer from "components/tokens/TokenTransfer";
import TokenDexTrading from "components/tokens/TokenDexTrading";
import TokenDistribution from "components/tokens/TokenDistribution";
import TokenPrice from "components/tokens/TokenPrice";

const Tokens = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container py-6">
          <div className="w-full px-2.5 md:px-3 lg:px-5">
            <div className="w-full flex items-center ">
              <div className="md:flex justify-between w-full md:py-6 md:gap-6">
                <div className="md:mb-0 mb-4">
                  <p className="relative text-header text-white mb-3 flex items-center gap-2">
                    <img
                      width={40}
                      height={40}
                      src={USDCIcon}
                      className="mr-2"
                      alt=""
                    />
                    Token USDC
                    <span className="text-h3 mr-2">(USDC)</span>
                    <img
                      width={29}
                      height={29}
                      src={VerifiedIcon}
                      alt=""
                    />
                  </p>
                </div>
                <SearchField
                  extra="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                  id="email"
                  type="text"
                />
              </div>
            </div>
            <div className="w-full flex text-center mt-3 md:mt-1">
              <div className="ml-auto md:mr-0 mr-auto flex gap-4">
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Buy <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Exchange <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Play <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-6 md:mt-12 px-2.5 md:px-3 lg:px-5">
          <div className="grid grid-cols-1 lg:grid-cols-11 gap-6">
            <div className="box bg-white dark:bg-darkPrimary px-2.5 md:px-5 py-5 lg:col-span-11 xl:col-span-5">
              <div className="flex flex-col">
                <h1 className="text-large mb-3">Overview</h1>
                <div className="flex gap-6 items-center">
                  <img 
                    src={USDCIcon}
                    width={110}
                    height={110}
                    alt=""
                  />
                  <div className="flex flex-col gap-2.5 grow">
                    <div className="flex justify-between max-w-[330px]">
                      <span className="text-gray-700 dark:text-gray-300">Max Total Suply</span>
                      <span className="">76,889,775,071.39 USDC</span>
                    </div>
                    <div className="flex justify-between max-w-[330px]">
                      <span className="text-gray-700 dark:text-gray-300">Holders</span>
                      <div className="flex items-center">
                        <span className="">3,333<span className="text-green-900">(+4.58%)</span></span>
                      </div>
                    </div>
                    <div className="flex justify-between max-w-[330px]">
                      <span className="text-gray-700 dark:text-gray-300">Total transfers</span>
                      <span className="">3,047</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="box bg-white dark:bg-darkPrimary overflow-hidden px-2.5 md:px-5 py-5 lg:col-span-5 xl:col-span-3">
              <div className="flex flex-col gap-3">
                <h1 className="text-large">Market</h1>
                <div className="flex justify-between max-w-[330px]">
                  <span className="text-gray-700 dark:text-gray-300">Price</span>
                  <span className="">$1.00 <span className="text-gray-700 dark:text-gray-300">1.00 BBA</span></span>
                </div>
                <div className="flex justify-between max-w-[330px]">
                  <span className="text-gray-700 dark:text-gray-300">On Chain Market Cap</span>
                  <div className="flex items-center">
                    <span className="">$32,142,492,274.86</span>
                  </div>
                </div>
                <div className="flex justify-between max-w-[330px]">
                  <span className="text-gray-700 dark:text-gray-300">Circulating Supply Market Cap</span>
                  <div className="flex items-center">
                    <span className="">$32,142,492,274.86</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="box bg-white dark:bg-darkPrimary overflow-hidden px-2.5 md:px-5 py-5 lg:col-span-6 xl:col-span-3">
              <div className="flex flex-col gap-3">
                <h1 className="text-large">Other Info</h1>
                <div className="flex justify-between max-w-[330px]">
                  <span className="text-gray-700 dark:text-gray-300">Token Name</span>
                  <div className="flex items-center">
                    <span className="">USD Coin (USDC)</span>
                  </div>
                </div>
                <div className="flex justify-between max-w-[330px]">
                  <span className="text-gray-700 dark:text-gray-300">Decimals</span>
                  <div className="flex items-center">
                    <span className="">6</span>
                  </div>
                </div>
                <p className="text-gray-700 dark:text-gray-300">Token Address</p>
                <div className="flex">
                  <div className="truncateWrapper">
                    <p className="text-xsmall truncate">
                    BrW3yUL4E3WDtK8Dyy5zvVs1KifxfVjKztvEDNxQhz7b
                    </p>
                  </div>
                  <button className="text-gray-900 dark:text-gray-300"><IoIosCopy /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`mt-6 mb-12 px-2.5 md:px-3 lg:px-5`}>
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden py-5">
            <div className="flex gap-2.5 flex-wrap px-2.5 md:px-5 ">
              <button className={`btn btn-tab ${tabIndex === 0 ? 'active' : ''}`} onClick={() => setTabIndex(0)}>
                Transfers
              </button>
              <button className={`btn btn-tab ${tabIndex === 1 ? 'active' : ''}`} onClick={() => setTabIndex(1)}>
                Holders
              </button>
              <button className={`btn btn-tab ${tabIndex === 2 ? 'active' : ''}`} onClick={() => setTabIndex(2)}>
                Info
              </button>
              <button className={`btn btn-tab ${tabIndex === 3 ? 'active' : ''}`} onClick={() => setTabIndex(3)}>
                Dex Trades
              </button>
              <button className={`btn btn-tab ${tabIndex === 4 ? 'active' : ''}`} onClick={() => setTabIndex(4)}>
                Analytics
              </button>
            </div>
            <div className="flex flex-col mt-5">
              <div className={`w-full ${tabIndex === 0 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3 px-2.5 md:px-5">
                More than 10,000,000 transactions found
                </div>
                <div className="table-wrapper">
                  <table className="table w-full">
                    <thead>
                      <tr className="">
                        <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large" data-for="txs-tip" data-tip="See preview of Transactions Details"><PiQuestionLight /></a></th>
                        <th className="">Token</th>
                        <th className="">Txn Hash</th>
                        <th className="">Block</th>
                        <th className="">Age</th>
                        <th className="">From</th>
                        <th className="">To</th>
                        <th className="">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Array(3).fill(0).map((data, index) => <tr className="">
                          <td className="!pr-0">
                            <a href="#" className="text-large"><PiEyeLight /></a>
                          </td>
                          <td>
                            <Link to="/token/usdc" className="text-small flex items-center gap-1">
                              <img
                                src={USDCIcon}
                                width={24}
                                height={24}
                              />
                              USDC
                            </Link>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                                  3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                                </Link>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small text-green-900">109,901,461</p>
                          </td>
                          <td>
                            <p className="text-small ">12 secs ago</p>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small ">100,000</p>
                          </td>
                        </tr>)
                      }
                      
                    </tbody>
                  </table>
                </div>
                <div className="pt-5 px-2.5 md:px-5 justify-center md:justify-between flex mb-2">
                  <div className="md:flex gap-2 hidden">
                    <span className="text-small flex items-center">Show</span>
                    <select className="text-small">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                    <span className="text-small flex items-center">Per Page</span>
                  </div>
                  <div className="flex gap-2">
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                    <span className="text-small flex items-center px-2">Page 1 of 25</span>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
                  </div>
                </div>
              </div>
              <div className={`w-full ${tabIndex === 1 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3 px-2.5 md:px-5">
                More than 10,000,000 transactions found
                </div>
                <div className="table-wrapper">
                  <table className="table w-full">
                    <thead>
                      <tr className="">
                        <th className="w-[10px] !min-w-0 !pr-0">#</th>
                        <th className="">Address</th>
                        <th className="">Quantity</th>
                        <th className="">Percentage</th>
                        <th className="">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Array(3).fill(0).map((data, index) => <tr>
                          <td className="!pr-0">
                            <a href="#" className="text-large">{index + 1}</a>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                                  3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                                </Link>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small ">50,170,530,484</p>
                          </td>
                          <td>
                            <p className="text-small ">7.2458%</p>
                          </td>
                          <td>
                            <p className="text-small">$50,170,530,484.00</p>
                          </td>
                        </tr>)
                      }
                      
                    </tbody>
                  </table>
                </div>
                <div className="pt-5 px-2.5 md:px-5 justify-center md:justify-between flex mb-2">
                  <div className="md:flex gap-2 hidden">
                    <span className="text-small flex items-center">Show</span>
                    <select className="text-small">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                    <span className="text-small flex items-center">Per Page</span>
                  </div>
                  <div className="flex gap-2">
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                    <span className="text-small flex items-center px-2">Page 1 of 25</span>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
                  </div>
                </div>
              </div>
              <div className={`w-full px-2.5 md:px-5 ${tabIndex === 2 ? '' : 'hidden'}`}>
                <div className="not-italic text-large pb-3 border-b-[1px] border-gray-100 dark:border-lightGrey w-full">
                  Overview
                </div>
                <div className="py-2.5">
                  USDC is a US dollar-backed stablecoin issued by Circle. USDC is designed to provide a faster, safer, and more efficient way to send, spend, and exchange money around the world.
                </div>
                <div className="not-italic text-large pb-3 border-b-[1px] border-gray-100 dark:border-lightGrey w-full mt-2.5">
                  Market
                </div>
                <div className="py-2.5 space-y-1">
                  <p>Volume (24H):$8,252,053,020.00</p>
                  <p>Market Capitalization:$45,669,413,567.00</p>
                  <p>Circulating Supply:45,669,834,061.00</p>
                  <p>USDCMarket Data Source: <span className="text-green-900">Coinmarketcap</span></p>
                </div>
              </div>
              <div className={`w-full ${tabIndex === 3 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3 px-2.5 md:px-5">
                More than 10,000,000 transactions found
                </div>
                <div className="table-wrapper">
                  <table className="table w-full">
                    <thead>
                      <tr className="">
                        <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large" data-for="txs-tip" data-tip="See preview of Transactions Details"><PiQuestionLight /></a></th>
                        <th className="">Txn Hash</th>
                        <th className="">Age</th>
                        <th className="">Action</th>
                        <th className="">Token Amount (Out)</th>
                        <th className="">Token Amount (In)</th>
                        <th className="">Swapped  Rate</th>
                        <th className="">Txn Value</th>
                        <th className="w-[10px] !min-w-0">Dex</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Array(3).fill(0).map((data, index) => <tr className="">
                          <td className="!pr-0">
                            <a href="#" className="text-large"><PiEyeLight /></a>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                                  3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                                </Link>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small ">12 secs ago</p>
                          </td>
                          <td>
                            <p className="text-small">
                              {
                                index % 2 ? <span className="text-red">Sell</span>
                                  : <span className="text-green-900">Buy</span>
                              }
                            </p>
                          </td>
                          <td>
                            <p className="text-small ">0.39484931 WBTC</p>
                          </td>
                          <td>
                            <p className="text-small ">37,412.591975 USDC</p>
                          </td>
                          <td>
                            <p className="text-small ">94,751.56984572</p>
                          </td>
                          <td>
                            <p className="text-small ">$37,412.59</p>
                          </td>
                          <td>
                            <img
                              src={DexIcon}
                              width={16}
                              height={16}
                              className="ml-auto"
                            />
                          </td>
                        </tr>)
                      }
                      
                    </tbody>
                  </table>
                </div>
                <div className="pt-5 px-2.5 md:px-5 justify-center flex w-full">
                  <Link to="#" className="btn-outline text-small flex gap-1">View All NFT Trades<RiArrowRightFill /></Link>
                </div>
              </div>
              <div className={`w-full ${tabIndex === 4 ? '' : 'hidden'}`}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-5 px-2.5 md:px-5">
                  <TokenTransfer />
                  <TokenDexTrading />
                  <TokenDistribution />
                  <TokenPrice />
                </div>
              </div>
            </div>
          </div>
          <div className={`text-gray-700 dark:text-gray-300 text-xsmall flex items-center mt-5 ${tabIndex === 2 || tabIndex === 3 ? '' : '!hidden'}`}>
            <span className="text-large mr-1 mb-1"><HiOutlineLightBulb /></span>
            <span>
              A token serves as a digital representation of assets, whether they exist on-chain or off-chain. The token overview page provides key details including current price, total supply, number of holders, transfer history, and relevant social media links. Discover more about this page in our guide.
              <span className="text-green-900 ml-1">Knowledge Hub</span>.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tokens;
